export { default } from "./PowerWordsContainer";
